import styled, { css } from 'styled-components'
import { fonts } from 'client/styles'

import {
  BIG_SIZE,
  PRIMARY_TYPE,
  PRIME_TYPE,
  SECONDARY_TYPE,
  SMALL_SIZE,
  TERTIARY_TYPE,
} from './constants'

import {
  bigSizeStyle,
  disabledStyle,
  fullWidth,
  primaryStyle,
  primeStyle,
  secondaryStyle,
  smallSizeStyle,
  tertiaryStyle,
} from 'client/styles/variants'

const hideButton = css`
  display: none;
`

export const ButtonSimpleBase = styled.button`
  display: flex;
  align-items: center;
  cursor: pointer;
  font-family: ${fonts.default};
  text-decoration: none;
  outline: none;
  min-width: 100px;

  ${props => props.size === BIG_SIZE && bigSizeStyle};
  ${props => props.size === SMALL_SIZE && smallSizeStyle};

  ${props => props.variant === PRIMARY_TYPE && primaryStyle};
  ${props => props.variant === SECONDARY_TYPE && secondaryStyle};
  ${props => props.variant === TERTIARY_TYPE && tertiaryStyle};
  ${props => props.variant === PRIME_TYPE && primeStyle};
  ${props => props.disabled && disabledStyle};

  border-radius: 8px;

  ${props => !props.isVisible && hideButton}
  ${props => props.fullWidth && fullWidth};
`

export const ButtonLoadingBase = styled(ButtonSimpleBase)`
  min-width: 100px;
  justify-content: center;
  pointer-events: none;
  ${props => props.size === BIG_SIZE && bigSizeStyle};
  ${props => props.size === SMALL_SIZE && smallSizeStyle};

  ${props => props.variant === PRIMARY_TYPE && primaryStyle};
  ${props => props.variant === SECONDARY_TYPE && secondaryStyle};
  ${props => props.variant === TERTIARY_TYPE && tertiaryStyle};

  ${props => !props.isVisible && hideButton}
  ${props => props.fullWidth && fullWidth};
`

export const ButtonText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  font-weight: 700;

  font-style: normal;
  width: 100%;
`
